require('boclips/components/boclips_modal')

LinkOpener =
  openResource: (url, openIn, event, data = {})->
    if openIn == 'disabled'
      if (event) then event.preventDefault()
      return false

    if LP.config.isMobile
      window.open(url, '_blank')
      return false

    switch openIn
      when 'rrp-modal'
        if (event) then event.preventDefault()
        RM = LP.module('Resources').ResourceModal
        new RM(url + '?mini_rrp=1').show()
      when 'boclips-modal'
        if (event) then event.preventDefault()
        BM = LP.module('LpBoclips').BoclipsModal
        params = $.extend(true, { mini_rpp: 1 }, data)
        new BM(url, data.originalUrl, params).show()
      when 'inline-play'
        window.open(url, '_self')
      else
        # default behavoir based on 'target' attribute

  # Binds onClick the resource rendering from:
  # CurriculumManager (CM)
  # Edit Collection Page.
  bindOpenResourceInCollections: ->
    classes = @.classesForBinding()
    $(document).off 'click', classes
    $(document).on 'click touch touchstart', classes, (e) ->
      open_in = e.currentTarget.getAttribute('data-open-in')
      if open_in && open_in != 'my-media-modal'
        data = $(e.currentTarget).data()
        LinkOpener.openResource(e.currentTarget.href, open_in, e, data)

  classesForBinding: ->
    [
      '.cb-item a',
      '#curriculum_manager .raw-title',
      '.panel-image a',
      '.panel-heading:not(.edit-collection-panel) a:not(.trk-goto-resource)',
      '#shared-resource-tool .raw-title',
      '.collection-card .collection-rrp-link',
      '.player-btn a'
      'a.collection-item-clickable'
    ].toString()

LP.module 'LinkOpener', LinkOpener

export default LinkOpener
